import { APP_LOAD, LOAD_PROFILE, RELOAD_PROFILE, UPDATE_PROFILE, LOGIN, LOGOUT, REGISTRATION, REQUEST_FAIL } from '../actions/actionTypes.js';
import isEqual from 'lodash/isEqual';

const initialState = null

export const currentUser = (state = initialState, action) => {
  switch (action.type) {
    case APP_LOAD.SUCCESS:
      return action.payload[0]
    case LOAD_PROFILE.SUCCESS:
    case REGISTRATION.SUCCESS:
    case LOGIN.SUCCESS:
      localStorage.removeItem('projectId')
      localStorage.removeItem('fte_completed')
      return isEqual(state, action.payload) ? state : action.payload;
    case UPDATE_PROFILE.SUCCESS:
    case RELOAD_PROFILE.SUCCESS:
      return {...state, ...action.payload};
    case LOGOUT:
      localStorage.removeItem('projectId')
      localStorage.removeItem('fte_completed')
      return initialState;
    case REQUEST_FAIL:
      if (action.payload.statusCode === 401){
        return initialState;
      }
      return state
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/session.js